<div class="main-container ac-table-page">

  <div class="page-header">
    <div class="title">
      <span class="title-text">Properties</span>
      <p class="small-title">
        {{ canManage
          ? 'View and manage the properties and their rooms at this branch.'
          : 'View the properties and rooms available at this branch.' }}
      </p>
    </div>

    @if(canManage){
    <div class="header-actions">
      @if(activeTab === 'utsav'){
      <button type="button" class="ac-primary-btn" [disabled]="!selectedUtsavId || isLoading" (click)="addPropertyToUtsav()">
        Add Property to Utsav
      </button>
      } @else {
      <button type="button" class="ac-primary-btn" [disabled]="isLoading" (click)="openForm(null)">
        Add Property
      </button>
      }
    </div>
    }
  </div>

  <div class="tab-filter-container">
    <div class="ac-tabs">
      <button
        type="button"
        class="ac-tab"
        [class.active]="activeTab === 'mandir'"
        (click)="setTab('mandir')"
      >
        Mandir Only
      </button>
      <button
        type="button"
        class="ac-tab"
        [class.active]="activeTab === 'utsav'"
        (click)="setTab('utsav')"
      >
        Utsav Only
      </button>
    </div>

    <div class="filters-row">
      @if (activeTab === 'utsav') {
      <span class="filter-label" id="specific-utsav-label">Select Utsav:</span>
      <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic" style="width: 280px;">
        <mat-select
          aria-labelledby="specific-utsav-label"
          panelClass="ac-select-panel"
          [disableOptionCentering]="true"
          [(value)]="selectedUtsavId"
          placeholder="Select utsav"
          (selectionChange)="onUtsavPicked()"
        >
          @for(utsav of filterUtsavList; track utsav.utsavId){
            <mat-option [value]="utsav.utsavId">{{ utsav.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      }

      <span class="filter-label" id="status-filter-label">Status:</span>
      <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic" style="width: 160px;">
        <mat-select
          aria-labelledby="status-filter-label"
          panelClass="ac-select-panel"
          [disableOptionCentering]="true"
          [(value)]="statusFilter"
          (selectionChange)="applyFilters()"
        >
          <mat-option value="all">All</mat-option>
          <mat-option value="active">Active</mat-option>
          <mat-option value="inactive">Inactive</mat-option>
        </mat-select>
      </mat-form-field>

      @if (activeTab === 'mandir') {
      <span class="filter-label" id="utsav-filter-label">Assigned to Utsav:</span>
      <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic" style="width: 240px;">
        <mat-select
          aria-labelledby="utsav-filter-label"
          panelClass="ac-select-panel"
          [disableOptionCentering]="true"
          [(value)]="utsavFilter"
          (selectionChange)="applyFilters()"
        >
          <mat-option [value]="'all'">All Utsavs</mat-option>
          @for(utsav of filterUtsavList; track utsav.utsavId){
            <mat-option [value]="utsav.utsavId">{{ utsav.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <label class="ac-check">
        <input
          type="checkbox"
          [checked]="unassignedOnly"
          (change)="unassignedOnly = $any($event.target).checked; applyFilters()"
        />
        Not assigned to any utsav
      </label>
      }
    </div>
  </div>

  @if (activeTab === 'utsav' && !selectedUtsavId) {
  <div class="empty-state">
    <span class="empty-state-title">Select an utsav</span>
    <span>The properties assigned to it will appear here.</span>
  </div>
  } @else {
  <div class="table-container ac-table-region" role="region" aria-label="Branch properties" tabindex="0">
    <table class="table ac-responsive-table ac-sortable-table" matSort [matSortDisableClear]="true" (matSortChange)="sortProperties($event)">
      <thead class="table-head">
        <tr>
          <th scope="col" mat-sort-header="name" data-mobile-sort>Name</th>
          <th scope="col" mat-sort-header="category">Category</th>
          <th scope="col" mat-sort-header="address">Address</th>
          <th scope="col" mat-sort-header="landmark">Landmark</th>
          <th scope="col" mat-sort-header="status" data-mobile-sort>Status</th>
          <th scope="col">Rooms</th>
          @if(canManage){ <th scope="col" class="ac-actions-column">Actions</th> }
        </tr>
      </thead>

      <tbody class="table-body">
        @for(property of properties; track property.propertyId){
        <tr>
          <td data-label="Name">{{ property.name }}</td>
          <td data-label="Category">{{ property.category === 'EXTERNAL' ? 'External' : 'Internal' }}</td>
          <td data-label="Address">{{ property.address || '-' }}</td>
          <td data-label="Landmark">{{ property.landmark || '-' }}</td>
          <td data-label="Status">{{ isActive(property.status) ? 'Active' : 'Inactive' }}</td>
          <td data-label="Rooms">
            <button type="button" class="ac-secondary-small-btn" (click)="toggleExpand(property)">
              {{ expandedPropertyId === property.propertyId ? 'Hide rooms' : 'View rooms' }}
              @if(activeTab !== 'utsav'){ ({{ property.activeRoomCount ?? 0 }}/{{ property.roomCount ?? 0 }}) }
            </button>
          </td>
          @if(canManage){
          <td class="actions-cell ac-actions-column" data-label="Actions">
            <div class="row-actions">
                <button type="button" class="ac-icon-btn" [disabled]="isLoading" (click)="openForm(property)" title="Edit property">
                  <span class="material-icons">edit</span>
                </button>
                @if(activeTab !== 'utsav'){
                <button type="button" class="ac-secondary-small-btn" [disabled]="isLoading" (click)="togglePropertyStatus(property)">
                  {{ isActive(property.status) ? 'Inactivate' : 'Activate' }}
                </button>
                }
                @if(activeTab === 'mandir' && isActive(property.status)){
                <button type="button" class="ac-secondary-small-btn" [disabled]="isLoading" (click)="openAssignDialog(property)">
                  Assign to Utsav
                </button>
                }
                @if(activeTab === 'utsav'){
                <button type="button" class="ac-secondary-small-btn" [disabled]="isLoading" (click)="unassignPropertyFromUtsav(property)">
                  Unassign
                </button>
                }
            </div>
          </td>
          }
        </tr>

        @if(expandedPropertyId === property.propertyId){
        <tr class="ac-detail-row">
          <td [attr.colspan]="canManage ? 7 : 6">
            <div class="rooms-panel">
              <div class="rooms-panel-head">
                <span class="rooms-panel-title">Rooms — {{ property.name }}</span>
                @if(canManage && activeTab !== 'utsav'){
                <button type="button" class="ac-secondary-small-btn" [disabled]="isLoading" (click)="openRoomForm(property, null)">
                  Add Room
                </button>
                }
              </div>

              @if(!roomsLoaded(property.propertyId)){
              <div class="muted">Loading rooms…</div>
              } @else {
                @for(room of roomsForProperty(property.propertyId); track room.roomId){
                <div class="room-line">
                  <span class="room-info">
                    Room {{ room.roomNumber }} · {{ room.roomType }} · Capacity {{ room.capacity }}
                    · {{ room.gender }} · Floor {{ room.floor || '-' }}
                  </span>
                  <span class="room-status" [class.inactive]="!isActive(room.status)">
                    {{ isActive(room.status) ? 'Active' : 'Inactive' }}
                  </span>
                  <span class="room-actions">
                    @if(activeTab === 'utsav' || (room.utsavs && room.utsavs.length)){
                    <button type="button" class="ac-secondary-small-btn" [disabled]="isLoading" (click)="assignedStatus(property, room)">
                      Assigned Status
                    </button>
                    }
                    @if(canManage){
                      @if(activeTab === 'utsav'){
                      <button type="button" class="ac-icon-btn" [disabled]="isLoading" (click)="openRoomForm(property, room)" title="Edit room">
                        <span class="material-icons">edit</span>
                      </button>
                      <button type="button" class="ac-secondary-small-btn" [disabled]="isLoading" (click)="unassignRoomFromUtsav(room)">
                        Remove from Utsav
                      </button>
                      } @else {
                      <button type="button" class="ac-icon-btn" [disabled]="isLoading" (click)="openRoomForm(property, room)" title="Edit room">
                        <span class="material-icons">edit</span>
                      </button>
                      <button type="button" class="ac-secondary-small-btn" [disabled]="isLoading" (click)="toggleRoomStatus(room)">
                        {{ isActive(room.status) ? 'Inactivate' : 'Activate' }}
                      </button>
                      @if(room.utsavs && room.utsavs.length){
                      <button type="button" class="ac-secondary-small-btn" [disabled]="isLoading" (click)="removeRoomFromUtsavMandir(room)">
                        Remove from Utsav
                      </button>
                      } @else if(isActive(room.status)){
                      <button type="button" class="ac-secondary-small-btn" [disabled]="isLoading" (click)="assignRoomToUtsav(room)">
                        Assign to Utsav
                      </button>
                      }
                      }
                    }
                  </span>
                </div>
                } @empty {
                <div class="muted">
                  {{ activeTab === 'utsav'
                    ? 'No rooms from this property are assigned to this utsav.'
                    : 'No rooms in this property yet.' }}
                </div>
                }
              }
            </div>
          </td>
        </tr>
        }
        }

        @if(!isLoading && properties.length === 0){
        <tr class="ac-empty-table-row">
          <td [attr.colspan]="canManage ? 7 : 6" class="empty-row">No Records Found</td>
        </tr>
        }
      </tbody>
    </table>
  </div>
  }

</div>

<app-loader [isLoading]="isLoading"></app-loader>
